import React from "react";
import { Loader2 } from "lucide-react";

/** Wraps children with a subtle overlay when `loading` is true.
 *  Content stays visible but is dimmed + non-interactive; a small spinner
 *  card sits center. Use inside any glass-card. */
export default function LoadingOverlay({ loading, children, testId }) {
  return (
    <div className="relative">
      <div className={loading ? "pointer-events-none opacity-40 transition-opacity duration-150" : "transition-opacity duration-150"}>
        {children}
      </div>
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none"
          data-testid={testId || "loading-overlay"}
        >
          <div className="glass-solid rounded-full px-3 py-1.5 flex items-center gap-2 shadow-md">
            <Loader2 className="w-3.5 h-3.5 animate-spin text-[#0A84FF]" />
            <span className="text-xs text-slate-700 font-medium">Loading…</span>
          </div>
        </div>
      )}
    </div>
  );
}
